/* eslint-disable react/no-array-index-key */
import React from "react"

export interface ProductConfiguratorOptionTextProps {
  title: React.ReactNode
  description: string[] | null | undefined
}

export const ProductConfiguratorOptionText = React.memo(
  ({ title, description }: ProductConfiguratorOptionTextProps) => (
    <div className="product-configurator-option__text">
      <div className="product-configurator-option__title">{title}</div>
      <div className="product-configurator-option__description">
        {description?.map((line: string, index: number) => (
          <div
            key={index}
            className="product-configurator-option__description-line"
          >
            {line}
          </div>
        ))}
      </div>
    </div>
  )
)
